module.exports = __webpack_public_path__ + "static/img/__7770.e987aa6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__7770.jpg
// module id = vdnC
// module chunks = 0